import {gql} from 'apollo-boost';
import {STUDENT_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_STUDENTASSIGNMENT = gql`
  query getStudentAssignment($id : ID!){
    getStudentAssignment (
      id: $id
    ) {
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName latitude longitude
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        ...StudentNameFields
        picturePath
      }

    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTASSIGNMENTS_BY_FILTER = gql`

  query getStudentAssignmentsByFilter($studentAssignmentFilterInput: StudentAssignmentFilterInput){
    getStudentAssignmentsByFilter (
      studentAssignmentFilterInput:$studentAssignmentFilterInput
    ){
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName latitude longitude
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        ...StudentNameFields
        picturePath
      }

    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTASSIGNMENTS = gql`
  query getStudentAssignments {
    getStudentAssignments {
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName latitude longitude
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        ...StudentNameFields
        picturePath
      }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const ADD_STUDENTASSIGNMENT = gql`
  mutation addStudentAssignment(
    $classSectionId: ID!
    $studentAssignmentInput: StudentAssignmentInput!
  ) {
    addStudentAssignment(
      classSectionId: $classSectionId
      studentAssignmentInput: $studentAssignmentInput
    ) {
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName latitude longitude
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        ...StudentNameFields
        picturePath
      }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const UPDATE_STUDENTASSIGNMENT = gql`
  mutation updateStudentAssignment(
    $id: ID!,
    $studentAssignmentInput: StudentAssignmentInput!
  ) {
    updateStudentAssignment(
      id: $id
      studentAssignmentInput: $studentAssignmentInput
    ) {
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName latitude longitude
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        ...StudentNameFields
        picturePath
      }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const UPDATE_STUDENTASSIGNMENT_TEACHER_RECEIVE = gql`
  mutation updateStudentAssignmentTeacherReceive(
    $id: ID!,
    $studentAssignmentInput: StudentAssignmentInput!
  ) {
    updateStudentAssignmentTeacherReceive(
      id: $id
      studentAssignmentInput: $studentAssignmentInput
    ) {
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName latitude longitude
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        ...StudentNameFields
        picturePath
      }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const DELETE_STUDENTASSIGNMENT = gql`
  mutation deleteStudentAssignment($id: ID!) {
    deleteStudentAssignment(
      id: $id
    ) {
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName latitude longitude
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        ...StudentNameFields
        picturePath
      }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

